"use strict";
// Auto-generated from Ambassador packages
// Do not edit manually - run 'yarn generate:public-types' to regenerate
Object.defineProperty(exports, "__esModule", { value: true });
exports.AriaInvalid = exports.AriaCurrent = exports.AriaLive = exports.AriaRole = exports.AriaRelevant = exports.AriaHaspopup = exports.AriaPressed = exports.LoginDialog = exports.TextLinkType = exports.LinkType = exports.LinkRelEnumLinkRel = exports.LinkTarget = exports.PropertySource = exports.StyleType = exports.SortOrderEnumSortOrder = exports.AdaptiveFormat = exports.VideoFormat = exports.VideoQuality = exports.DirectionValue = exports.DataType = void 0;
var DataType;
(function (DataType) {
    DataType["UNKNOWN_DataType"] = "UNKNOWN_DataType";
    /** A simple text value */
    DataType["text"] = "text";
    /** A list of predefined textual values to choose from */
    DataType["textEnum"] = "textEnum";
    /** Any number */
    DataType["number"] = "number";
    /** true / false value */
    DataType["booleanValue"] = "booleanValue";
    /** An object containing the selected A11Y fields chosen */
    DataType["a11y"] = "a11y";
    /** A Wix Link object type */
    DataType["link"] = "link";
    /** A Wix Image object type */
    DataType["image"] = "image";
    /** A Wix Video object type */
    DataType["video"] = "video";
    /** A Wix Sanitized Vector Art object */
    DataType["vectorArt"] = "vectorArt";
    /** A Wix Audio object */
    DataType["audio"] = "audio";
    /** DEPRECATED - use the `data` dataType instead. A [JSON Schema definition](https://json-schema.org/specification) the developer understands in his code (useful for complex props). Some limitation may apply. */
    DataType["schema"] = "schema";
    /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
    DataType["localDate"] = "localDate";
    /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
    DataType["localTime"] = "localTime";
    /** Local Date Time output  ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
    DataType["localDateTime"] = "localDateTime";
    /** a URL with scheme http or https */
    DataType["webUrl"] = "webUrl";
    /** standard email address according to [RFC 5321, section 4.1.2](https://datatracker.ietf.org/doc/html/rfc5321#section-4.1.2) */
    DataType["email"] = "email";
    /** a validation format designed to match phone numbers with a variety of common characters, including digits (0-9), spaces, parentheses, plus sign, hyphens, and periods */
    DataType["phone"] = "phone";
    /** hostname according to IANA */
    DataType["hostname"] = "hostname";
    /** A valid `regex` pattern supplied by the User */
    DataType["regex"] = "regex";
    /** A unique identifier */
    DataType["guid"] = "guid";
    /** a HTML text with css inline styling */
    DataType["richText"] = "richText";
    /** A container place in the component that will be passed in as {children} or a function prop, depending on the case */
    DataType["container"] = "container";
    /** An array type of data */
    DataType["arrayItems"] = "arrayItems";
    /** selected `direction` for the component according to (HTML `dir` attribute)[https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir] */
    DataType["direction"] = "direction";
    /** A list of menu-items */
    DataType["menuItems"] = "menuItems";
    /** A complex data type that can be used to define a data structure, such as an object or a map */
    DataType["data"] = "data";
    /** A custom function that can be used to call a function from a custom library */
    DataType["function"] = "function";
    /** Deprecated: use function with pointerEvent parameter. Standard [onClick handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/click_event) */
    DataType["onClick"] = "onClick";
    /** Deprecated: use function with changeEvent parameter. Standard [onChange handler](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event) */
    DataType["onChange"] = "onChange";
    /** Deprecated: use function with keyboardEvent parameter. Standard [onKeyPress handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/keypress_event) */
    DataType["onKeyPress"] = "onKeyPress";
    /** Deprecated: use function with keyboardEvent parameter. Standard [onKeyUp handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/keyup_event) */
    DataType["onKeyUp"] = "onKeyUp";
    /** Deprecated: use function with submitEvent parameter. Standard [onSubmit handler](https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/submit_event) */
    DataType["onSubmit"] = "onSubmit";
    /** A WQL-compliant filter definition for querying data */
    DataType["filter"] = "filter";
    /** A WQL-compliant sort definition for ordering data */
    DataType["sort"] = "sort";
})(DataType || (exports.DataType = DataType = {}));
var DirectionValue;
(function (DirectionValue) {
    /** Unspecified direction. */
    DirectionValue["UNKNOWN_DIRECTION"] = "UNKNOWN_DIRECTION";
    /** Left-to-right. */
    DirectionValue["LTR"] = "LTR";
    /** Right-to-left. */
    DirectionValue["RTL"] = "RTL";
    /** Automatic detection. */
    DirectionValue["AUTO"] = "AUTO";
})(DirectionValue || (exports.DirectionValue = DirectionValue = {}));
var VideoQuality;
(function (VideoQuality) {
    /** Unspecified quality. */
    VideoQuality["UNKNOWN_VIDEO_QUALITY"] = "UNKNOWN_VIDEO_QUALITY";
    /** 1080p HD quality. */
    VideoQuality["VIDEO_QUALITY_1080P"] = "VIDEO_QUALITY_1080P";
    /** 720p HD quality. */
    VideoQuality["VIDEO_QUALITY_720P"] = "VIDEO_QUALITY_720P";
    /** 480p SD quality. */
    VideoQuality["VIDEO_QUALITY_480P"] = "VIDEO_QUALITY_480P";
    /** 360p quality. */
    VideoQuality["VIDEO_QUALITY_360P"] = "VIDEO_QUALITY_360P";
})(VideoQuality || (exports.VideoQuality = VideoQuality = {}));
var VideoFormat;
(function (VideoFormat) {
    /** Unspecified format. */
    VideoFormat["UNKNOWN_VIDEO_FORMAT"] = "UNKNOWN_VIDEO_FORMAT";
    /** Standard MP4 format. */
    VideoFormat["MP4"] = "MP4";
    /** MP4 with luminance encoding. */
    VideoFormat["MP4_LUMINANCE"] = "MP4_LUMINANCE";
})(VideoFormat || (exports.VideoFormat = VideoFormat = {}));
var AdaptiveFormat;
(function (AdaptiveFormat) {
    /** Unspecified adaptive format. */
    AdaptiveFormat["UNKNOWN_ADAPTIVE_FORMAT"] = "UNKNOWN_ADAPTIVE_FORMAT";
    /** HTTP Live Streaming format. */
    AdaptiveFormat["HLS"] = "HLS";
    /** Dynamic Adaptive Streaming over HTTP. */
    AdaptiveFormat["DASH"] = "DASH";
})(AdaptiveFormat || (exports.AdaptiveFormat = AdaptiveFormat = {}));
var SortOrderEnumSortOrder;
(function (SortOrderEnumSortOrder) {
    /** Unknown sort order. */
    SortOrderEnumSortOrder["UNKNOWN_SORT_ORDER"] = "UNKNOWN_SORT_ORDER";
    /** Ascending order. */
    SortOrderEnumSortOrder["ASC"] = "ASC";
    /** Descending order. */
    SortOrderEnumSortOrder["DESC"] = "DESC";
})(SortOrderEnumSortOrder || (exports.SortOrderEnumSortOrder = SortOrderEnumSortOrder = {}));
var StyleType;
(function (StyleType) {
    /** Unknown style type. */
    StyleType["UNKNOWN_STYLE_TYPE"] = "UNKNOWN_STYLE_TYPE";
    /** CSS-based styling. */
    StyleType["CSS"] = "CSS";
    /** Legacy styling for classic and Studio site components. */
    StyleType["LEGACY"] = "LEGACY";
    /** Reference to a theme style. */
    StyleType["THEME"] = "THEME";
})(StyleType || (exports.StyleType = StyleType = {}));
var PropertySource;
(function (PropertySource) {
    /** Unknown property source. */
    PropertySource["UNKNOWN_PROPERTY_SOURCE"] = "UNKNOWN_PROPERTY_SOURCE";
    /** Property value comes from theme. */
    PropertySource["THEME"] = "THEME";
    /** Property has explicit value. */
    PropertySource["VALUE"] = "VALUE";
})(PropertySource || (exports.PropertySource = PropertySource = {}));
var LinkTarget;
(function (LinkTarget) {
    LinkTarget["UNKNOWN_LINK_TARGET"] = "UNKNOWN_LINK_TARGET";
    /** Opens the linked document in the same frame as it was clicked (default). */
    LinkTarget["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab. */
    LinkTarget["BLANK"] = "BLANK";
})(LinkTarget || (exports.LinkTarget = LinkTarget = {}));
var LinkRelEnumLinkRel;
(function (LinkRelEnumLinkRel) {
    LinkRelEnumLinkRel["UNKNOWN_LINK_REL"] = "UNKNOWN_LINK_REL";
    /** Instructs search engines not to follow the link. */
    LinkRelEnumLinkRel["NOFOLLOW"] = "NOFOLLOW";
    /** Prevents the new page from being able to access the window.opener property. */
    LinkRelEnumLinkRel["NOOPENER"] = "NOOPENER";
    /** Prevents the browser from sending the current page's address as referrer information when following the link. */
    LinkRelEnumLinkRel["NOREFERRER"] = "NOREFERRER";
    /** Indicates that the link is a paid link or an advertisement. */
    LinkRelEnumLinkRel["SPONSORED"] = "SPONSORED";
})(LinkRelEnumLinkRel || (exports.LinkRelEnumLinkRel = LinkRelEnumLinkRel = {}));
var LinkType;
(function (LinkType) {
    /** Unknown link type. */
    LinkType["UNKNOWN_LINK_TYPE"] = "UNKNOWN_LINK_TYPE";
    /** Link to a page on the same site. */
    LinkType["PAGE_LINK"] = "PAGE_LINK";
    /** Link to an external URL. */
    LinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    /** Link that opens an email client. */
    LinkType["EMAIL_LINK"] = "EMAIL_LINK";
    /** Link to an anchor on a page. */
    LinkType["ANCHOR_LINK"] = "ANCHOR_LINK";
    /** Link to a downloadable document. */
    LinkType["DOCUMENT_LINK"] = "DOCUMENT_LINK";
    /** Link that initiates a phone call. */
    LinkType["PHONE_LINK"] = "PHONE_LINK";
    /** Link to a dynamic page route. */
    LinkType["DYNAMIC_PAGE_LINK"] = "DYNAMIC_PAGE_LINK";
    /** Text-based link. */
    LinkType["TEXT_LINK"] = "TEXT_LINK";
    /** Link that opens a login or signup dialog. */
    LinkType["LOGIN_TO_WIX_LINK"] = "LOGIN_TO_WIX_LINK";
    /** Link that opens WhatsApp. */
    LinkType["WHATS_APP_LINK"] = "WHATS_APP_LINK";
    /** Link to a physical address on a map. */
    LinkType["ADDRESS_LINK"] = "ADDRESS_LINK";
    /** Link to an app page. */
    LinkType["APP_PAGE_LINK"] = "APP_PAGE_LINK";
})(LinkType || (exports.LinkType = LinkType = {}));
var TextLinkType;
(function (TextLinkType) {
    /** Unknown text link type. */
    TextLinkType["UNKNOWN_TEXT_LINK_TYPE"] = "UNKNOWN_TEXT_LINK_TYPE";
    /** SMS message link. */
    TextLinkType["SMS"] = "SMS";
    /** Phone call link. */
    TextLinkType["CALL"] = "CALL";
    /** Skype link. */
    TextLinkType["SKYPE"] = "SKYPE";
    /** Map link. */
    TextLinkType["MAP"] = "MAP";
    /** Email link. */
    TextLinkType["EMAIL"] = "EMAIL";
    /** Facebook link. */
    TextLinkType["FACEBOOK"] = "FACEBOOK";
    /** Flickr link. */
    TextLinkType["FLICKR"] = "FLICKR";
    /** LinkedIn link. */
    TextLinkType["LINKEDIN"] = "LINKEDIN";
    /** Twitter link. */
    TextLinkType["TWITTER"] = "TWITTER";
    /** Tumblr link. */
    TextLinkType["TUMBLR"] = "TUMBLR";
    /** YouTube link. */
    TextLinkType["YOUTUBE"] = "YOUTUBE";
    /** Vimeo link. */
    TextLinkType["VIMEO"] = "VIMEO";
    /** Internal page link. */
    TextLinkType["PAGE"] = "PAGE";
    /** Custom URL link. */
    TextLinkType["FREE_LINK"] = "FREE_LINK";
    /** Text link. */
    TextLinkType["TEXT"] = "TEXT";
    /** External website link. */
    TextLinkType["WEBSITE"] = "WEBSITE";
    /** Document link. */
    TextLinkType["DOCUMENT"] = "DOCUMENT";
    /** Admin login link. */
    TextLinkType["ADMIN_LOGIN"] = "ADMIN_LOGIN";
    /** Login link. */
    TextLinkType["LOGIN"] = "LOGIN";
})(TextLinkType || (exports.TextLinkType = TextLinkType = {}));
var LoginDialog;
(function (LoginDialog) {
    /** Unknown login dialog type. */
    LoginDialog["UNKNOWN_LOGIN_DIALOG"] = "UNKNOWN_LOGIN_DIALOG";
    /** Shows the signup registration form directly. */
    LoginDialog["CREATE_USER"] = "CREATE_USER";
    /** Shows a login-only dialog without a signup option. This is the default value. */
    LoginDialog["LOGIN"] = "LOGIN";
    /** Shows a login dialog that also includes an option to switch to signup. */
    LoginDialog["LOGIN_WITH_SIGNUP"] = "LOGIN_WITH_SIGNUP";
})(LoginDialog || (exports.LoginDialog = LoginDialog = {}));
var AriaPressed;
(function (AriaPressed) {
    AriaPressed["UNKNOWN_ARIA_PRESSED"] = "UNKNOWN_ARIA_PRESSED";
    /** The element is not pressed. */
    AriaPressed["FALSE"] = "FALSE";
    /** The element is pressed. */
    AriaPressed["TRUE"] = "TRUE";
    /** The element is partially pressed. */
    AriaPressed["MIXED"] = "MIXED";
})(AriaPressed || (exports.AriaPressed = AriaPressed = {}));
var AriaHaspopup;
(function (AriaHaspopup) {
    AriaHaspopup["UNKNOWN_ARIA_HASPOPUP"] = "UNKNOWN_ARIA_HASPOPUP";
    /** The element has a popup. */
    AriaHaspopup["TRUE"] = "TRUE";
    /** The element does not have a popup. */
    AriaHaspopup["FALSE"] = "FALSE";
    /** The popup is a dialog. */
    AriaHaspopup["DIALOG"] = "DIALOG";
    /** The popup is a menu. */
    AriaHaspopup["MENU"] = "MENU";
})(AriaHaspopup || (exports.AriaHaspopup = AriaHaspopup = {}));
var AriaRelevant;
(function (AriaRelevant) {
    AriaRelevant["UNKNOWN_ARIA_RELEVANT"] = "UNKNOWN_ARIA_RELEVANT";
    /** Element nodes added to the accessibility tree. */
    AriaRelevant["ADDITIONS"] = "ADDITIONS";
    /** Both additions and text changes. */
    AriaRelevant["ADDITIONS_TEXT"] = "ADDITIONS_TEXT";
    /** All changes. */
    AriaRelevant["ALL"] = "ALL";
    /** Element nodes removed from the accessibility tree. */
    AriaRelevant["REMOVALS"] = "REMOVALS";
    /** Text changes. */
    AriaRelevant["TEXT"] = "TEXT";
})(AriaRelevant || (exports.AriaRelevant = AriaRelevant = {}));
var AriaRole;
(function (AriaRole) {
    AriaRole["UNKNOWN_ARIA_ROLE"] = "UNKNOWN_ARIA_ROLE";
    AriaRole["REGION"] = "REGION";
    AriaRole["GROUP"] = "GROUP";
    AriaRole["TABLIST"] = "TABLIST";
    AriaRole["TAB"] = "TAB";
    AriaRole["TABPANEL"] = "TABPANEL";
    AriaRole["ALERT"] = "ALERT";
    AriaRole["STATUS"] = "STATUS";
    AriaRole["LIST"] = "LIST";
    AriaRole["LISTITEM"] = "LISTITEM";
    AriaRole["MENUBAR"] = "MENUBAR";
    AriaRole["PRESENTATION"] = "PRESENTATION";
    AriaRole["BUTTON"] = "BUTTON";
    AriaRole["LINK"] = "LINK";
    AriaRole["NONE"] = "NONE";
    AriaRole["RADIOGROUP"] = "RADIOGROUP";
    AriaRole["HEADING"] = "HEADING";
    AriaRole["NAV"] = "NAV";
})(AriaRole || (exports.AriaRole = AriaRole = {}));
var AriaLive;
(function (AriaLive) {
    AriaLive["UNKNOWN_ARIA_LIVE"] = "UNKNOWN_ARIA_LIVE";
    /** Updates are announced when the user is idle. */
    AriaLive["POLITE"] = "POLITE";
    /** Updates are announced immediately. */
    AriaLive["ASSERTIVE"] = "ASSERTIVE";
})(AriaLive || (exports.AriaLive = AriaLive = {}));
var AriaCurrent;
(function (AriaCurrent) {
    AriaCurrent["UNKNOWN_ARIA_CURRENT"] = "UNKNOWN_ARIA_CURRENT";
    /** Represents the current page within a set of pages. */
    AriaCurrent["PAGE"] = "PAGE";
    /** Represents the current step within a process. */
    AriaCurrent["STEP"] = "STEP";
    /** Represents the current location within an environment. */
    AriaCurrent["LOCATION"] = "LOCATION";
    /** Represents the current date within a collection of dates. */
    AriaCurrent["DATE"] = "DATE";
    /** Represents the current time within a set of times. */
    AriaCurrent["TIME"] = "TIME";
    /** Represents the current item within a set. */
    AriaCurrent["TRUE"] = "TRUE";
    /** Does not represent the current item within a set. */
    AriaCurrent["FALSE"] = "FALSE";
})(AriaCurrent || (exports.AriaCurrent = AriaCurrent = {}));
var AriaInvalid;
(function (AriaInvalid) {
    AriaInvalid["UNKNOWN_ARIA_INVALID"] = "UNKNOWN_ARIA_INVALID";
    /** A grammatical error was detected. */
    AriaInvalid["GRAMMAR"] = "GRAMMAR";
    /** A spelling error was detected. */
    AriaInvalid["SPELLING"] = "SPELLING";
    /** There are no detected errors in the value. */
    AriaInvalid["FALSE"] = "FALSE";
    /** The value entered by the user has failed validation. */
    AriaInvalid["TRUE"] = "TRUE";
})(AriaInvalid || (exports.AriaInvalid = AriaInvalid = {}));
